import React, { useState, useEffect } from "react";
import axios from "axios";
import { auth, db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useFont } from "../context/FontContext"; 
import { useNavigate } from "react-router-dom";
// 🔥 GÖRSELLİK İÇİN GEREKLİ KÜTÜPHANELER EKLENDİ
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";
import { motion } from "framer-motion";
import ReactMarkdown from 'react-markdown'; 
import remarkGfm from 'remark-gfm'; 

export default function AiReport() {
    const { fontSize } = useFont(); 
    const navigate = useNavigate();

    const [report, setReport] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [user, setUser] = useState(null);

    // 1. KULLANICI KONTROLÜ VE ESKİ RAPORU ÇEKME
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
            if (currentUser) {
                setUser(currentUser);
                await checkExistingReport(currentUser.uid);
            } else {
                setError("Lütfen önce giriş yapın.");
            }
        });
        return () => unsubscribe();
    }, []);

    const checkExistingReport = async (userId) => {
        try {
            const docRef = doc(db, "users", userId, "reports", "latest");
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();
                console.log("📂 Eski rapor bulundu, yükleniyor...");
                setReport(data.reportResult);
                setChartData(data.chartData);
            }
        } catch (err) {
            console.error("Eski rapor çekilemedi:", err);
        }
    };

    // 2. TEST VERİSİ ÇEKME
    const getTestData = async (userId, testKey) => {
        const localData = localStorage.getItem(`${testKey}Results`);
        if (localData) return JSON.parse(localData);

        try {
            const docRef = doc(db, "users", userId, "answers", testKey);
            const docSnap = await getDoc(docRef);
            return docSnap.exists() ? docSnap.data() : null;
        } catch (err) {
            console.error(`🔥 Firebase Hatası (${testKey}):`, err);
            return null;
        }
    };

    // 3. RAPOR OLUŞTURMA
    const handleGenerateReport = async () => {
        if (!user) return;
        setLoading(true);
        setError("");
        
        try {
            const discData = await getTestData(user.uid, 'disc');
            const oceanData = await getTestData(user.uid, 'ocean');
            const riasecData = await getTestData(user.uid, 'riasec');

            if (!discData || !oceanData || !riasecData) {
                setError("⚠️ Eksik Test Var! Tam kapsamlı analiz için Dashboard'a gidip tüm testleri tamamla.");
                setLoading(false);
                return;
            }

            // Backend'e Gönder
            const response = await axios.post('http://localhost:5001/ai-report', { 
                disc: discData, ocean: oceanData, riasec: riasecData 
            });
            
            if (response.data.result) {
                const newReport = response.data.result;
                const newChartData = response.data.chartData;

                setReport(newReport);
                setChartData(newChartData);

                // Firebase'e Kaydet
                await setDoc(doc(db, "users", user.uid, "reports", "latest"), {
                    reportResult: newReport,
                    chartData: newChartData,
                    generatedAt: new Date()
                });
            } else {
                setError("Sunucudan boş cevap döndü.");
            }

        } catch (err) {
            console.error("Sunucu Hatası:", err);
            setError("Bağlantı Hatası: Backend (5001) açık mı?");
        } finally {
            setLoading(false);
        }
    };

    // --- YARDIMCI FONKSİYONLAR ---
    
    // Üniversite Metnini Ayrıştırıp Kartlara Çevirme
    const parseUniversities = (text) => {
        if (!text) return [];
        // Rapordaki "🎓 Sana Özel Üniversite Tavsiyeleri" başlığından sonrasını al
        const parts = text.split("🎓 Sana Özel Üniversite Tavsiyeleri");
        if (parts.length < 2) return [];
        
        const uniSection = parts[1];
        // Satır satır ayır ve işle
        return uniSection.split("* **").slice(1).map(line => {
            const splitLine = line.split("**");
            const name = splitLine[0]; // Üniversite Adı
            const rest = splitLine[1] || "";
            const match = rest.split(")")[0].replace("(", ""); // (%98 Uyum)
            const reason = rest.split("👉 *Neden?*")[1]?.trim(); // Neden metni
            return { name, match, reason };
        });
    };

    // Radar Grafiği Verisi Hazırlama
    const getRadarData = () => {
        if (!chartData) return [];
        const p = chartData.userProfile;
        return [
            { subject: "Analitik", A: p.A, fullMark: 100 },
            { subject: "Sosyal", A: p.S, fullMark: 100 },
            { subject: "Yaratıcılık", A: p.Y, fullMark: 100 },
            { subject: "Disiplin", A: p.D, fullMark: 100 },
        ];
    };

    const universities = report ? parseUniversities(report) : [];

    // --- MODERN STİLLER ---
    const styles = {
        container: { maxWidth: 1000, margin: "40px auto", padding: 40, backgroundColor: '#fff', borderRadius: '24px', boxShadow: '0 20px 60px rgba(0,0,0,0.05)', fontFamily: 'Segoe UI, sans-serif' },
        header: { textAlign: 'center', marginBottom: 50 },
        btnMain: { padding: "16px 40px", background: "linear-gradient(135deg, #4F46E5, #7C3AED)", color: "white", borderRadius: 50, border: 'none', fontSize: `${fontSize + 2}px`, cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 10px 25px rgba(79, 70, 229, 0.3)', transition: 'transform 0.2s' },
        chartSection: { display: 'flex', flexWrap: 'wrap', gap: '30px', marginBottom: '50px' },
        chartBox: { flex: 1, minWidth: '300px', background: '#F9FAFB', borderRadius: '20px', padding: '20px' },
        scoreBox: { flex: 1, minWidth: '300px', background: 'linear-gradient(135deg, #3B82F6, #2563EB)', color: 'white', borderRadius: '20px', padding: '40px', display: 'flex', flexDirection: 'column', justifyContent: 'center', boxShadow: '0 20px 40px -10px rgba(37, 99, 235, 0.4)' },
        uniCard: { background: '#fff', padding: '20px', borderRadius: '15px', marginBottom: '15px', border: '1px solid #eee', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' },
        roadmapCard: { background: '#f8f9fa', padding: '20px', borderRadius: '15px', borderLeft: '5px solid #00b894' },
        errorBox: { backgroundColor: '#ffebee', color: '#c62828', padding: 15, borderRadius: 10, textAlign: 'center', marginTop: 20 }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h1 style={{fontSize: `${fontSize + 16}px`, fontWeight:'800', color: '#111827'}}>
                    🚀 Gelecek Analiz Raporu
                </h1>
                <p style={{color:'#6B7280', fontSize: `${fontSize + 2}px`}}>
                    Yapay Zeka Destekli Kariyer Planlaması
                </p>
                <br/>
                <button 
                    onClick={handleGenerateReport} 
                    style={styles.btnMain} 
                    disabled={loading}
                    onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                >
                    {loading ? "Analiz Ediliyor... 🧠" : (report ? "🔄 Raporu Güncelle" : "✨ Analizi Başlat")}
                </button>

                {report && !loading && <p style={{color:'#27ae60', marginTop:10, fontSize:'14px'}}>✅ Rapor kaydedildi.</p>}
                {error && <div style={styles.errorBox}>{error}</div>}
            </div>

            {report && chartData && (
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
                    
                    {/* 1. GRAFİK VE SKOR KARTLARI */}
                    <div style={styles.chartSection}>
                        {/* Radar Grafiği */}
                        <div style={styles.chartBox}>
                            <h3 style={{textAlign:'center', color:'#374151', marginBottom:20}}>Yetkinlik Haritası</h3>
                            <div style={{width:'100%', height:'300px'}}>
                                <ResponsiveContainer>
                                    <RadarChart cx="50%" cy="50%" outerRadius="75%" data={getRadarData()}>
                                        <PolarGrid stroke="#E5E7EB" />
                                        <PolarAngleAxis dataKey="subject" tick={{ fill: '#6B7280', fontSize: 12 }} />
                                        <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} />
                                        <Radar name="Sen" dataKey="A" stroke="#4F46E5" strokeWidth={3} fill="#4F46E5" fillOpacity={0.2} />
                                    </RadarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>

                        {/* En İyi Meslek Kartı */}
                        <div style={styles.scoreBox}>
                            <h3 style={{opacity:0.9, fontSize:'1.1rem'}}>Yapay Zeka Önerisi</h3>
                            <h1 style={{fontSize:'3rem', fontWeight:'800', margin:'10px 0', lineHeight:1}}>
                                {chartData.topJob.name}
                            </h1>
                            <div style={{marginTop:15}}>
                                <span style={{background:'rgba(255,255,255,0.2)', padding:'8px 16px', borderRadius:20, fontSize:'1rem'}}>
                                    Uyum Skoru: <strong>%{chartData.topJob.match.toFixed(0)}</strong>
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* 2. RAPOR METNİ (MARKDOWN FORMATINDA) 🔥 DÜZELTİLEN KISIM */}
                    <div style={{background:'#F3F4F6', padding:'40px', borderRadius:'24px', border:'1px solid #E5E7EB', marginBottom:'40px'}}>
                        <div style={{lineHeight: '1.8', color: '#374151', fontSize: `${fontSize}px`}}>
                            <ReactMarkdown 
                                remarkPlugins={[remarkGfm]}
                                components={{
                                    h4: ({node, ...props}) => <h4 style={{color:'#4F46E5', fontSize:'1.4rem', marginTop:'30px', marginBottom:'15px', borderBottom:'2px solid #E5E7EB', paddingBottom:'10px'}} {...props} />,
                                    strong: ({node, ...props}) => <strong style={{color:'#111827', fontWeight:'700'}} {...props} />,
                                    ul: ({node, ...props}) => <ul style={{paddingLeft:'20px', marginBottom:'20px'}} {...props} />,
                                    li: ({node, ...props}) => <li style={{marginBottom:'10px'}} {...props} />,
                                    p: ({node, ...props}) => <p style={{marginBottom:'15px'}} {...props} />
                                }}
                            >
                                {report}
                            </ReactMarkdown>
                        </div>
                    </div>

                    {/* 3. YOL HARİTASI (ROADMAP) */}
                    <h2 style={{color:'#111827', fontSize:`${fontSize + 6}px`, marginBottom:'20px'}}>🗺️ Başarı Yol Haritası</h2>
                    <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(250px, 1fr))', gap:'20px', marginBottom:'40px'}}>
                        {chartData.topJob.roadmap && chartData.topJob.roadmap.map((step, i) => (
                            <div key={i} style={styles.roadmapCard}>
                                <span style={{background:'#00b894', color:'white', padding:'5px 12px', borderRadius:'8px', fontSize:'12px', fontWeight:'bold'}}>
                                    {step.year}
                                </span>
                                <p style={{marginTop:'15px', fontSize: `${fontSize}px`, color:'#2d3436', fontWeight:'500'}}>
                                    {step.task}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* 4. ÜNİVERSİTE KARTLARI */}
                    <h2 style={{color:'#111827', fontSize:`${fontSize + 6}px`, marginBottom:'20px'}}>🎓 Sana Özel Üniversiteler</h2>
                    <div>
                        {universities.map((uni, i) => (
                            <div key={i} style={styles.uniCard}>
                                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                                    <h3 style={{color:'#2d3436', margin:0, fontSize:`${fontSize + 4}px`}}>{uni.name}</h3>
                                    <span style={{background:'#6c5ce7', color:'white', padding:'5px 15px', borderRadius:'20px', fontSize:'13px', fontWeight:'bold'}}>
                                        {uni.match}
                                    </span>
                                </div>
                                <p style={{marginTop:'15px', color:'#636e72', fontSize:`${fontSize}px`, lineHeight:'1.6'}}>
                                    👉 <strong style={{color:'#2d3436'}}>Neden?</strong> {uni.reason}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* 5. SİMÜLASYON YÖNLENDİRMESİ */}
                    <div style={{marginTop:60, textAlign:'center'}}>
                        <h3 style={{fontSize:`${fontSize + 4}px`, marginBottom:'10px'}}>Maceraya Hazır Mısın?</h3>
                        <p style={{color:'#666', marginBottom:'20px'}}>
                            Bu mesleğin gerçek hayatta nasıl olduğunu <strong>oynayarak</strong> deneyimle.
                        </p>
                        <button 
                            onClick={() => navigate('/career-sim', { state: { jobName: chartData.topJob.name } })}
                            style={{...styles.btnMain, background:'#F59E0B', boxShadow:'0 10px 25px -5px rgba(245, 158, 11, 0.4)'}}
                        >
                            🎭 {chartData.topJob.name} Simülasyonunu Oyna ▶
                        </button>
                    </div>

                </motion.div>
            )}
        </div>
    );
}